import { STANDARD_HOOKS } from "../api/config/config";
export const useInitializeNewConversation = props => {
  var _referralQuery$data, _referralQuery$data2, _caseQuery$data, _caseQuery$data2, _caseQuery$data3;
  const {
    subjectId,
    subjectType
  } = props;
  const {
    useFindRecord
  } = STANDARD_HOOKS;
  const referralQuery = useFindRecord("referral", subjectId, {
    queryConfig: {
      enabled: subjectType === "referral"
    }
  });
  // caseQuery should always fire if we have a subject type + id as it's the basis for all our messages
  const caseQuery = useFindRecord("case_summary", subjectType === "case" ? subjectId : referralQuery === null || referralQuery === void 0 || (_referralQuery$data = referralQuery.data) === null || _referralQuery$data === void 0 || (_referralQuery$data = _referralQuery$data.data) === null || _referralQuery$data === void 0 || (_referralQuery$data = _referralQuery$data.data) === null || _referralQuery$data === void 0 || (_referralQuery$data = _referralQuery$data.case_summary) === null || _referralQuery$data === void 0 ? void 0 : _referralQuery$data.id, {
    queryConfig: {
      enabled: Boolean(subjectType && subjectId && (subjectType === "referral" ? referralQuery === null || referralQuery === void 0 || (_referralQuery$data2 = referralQuery.data) === null || _referralQuery$data2 === void 0 || (_referralQuery$data2 = _referralQuery$data2.data) === null || _referralQuery$data2 === void 0 || (_referralQuery$data2 = _referralQuery$data2.data) === null || _referralQuery$data2 === void 0 || (_referralQuery$data2 = _referralQuery$data2.case_summary) === null || _referralQuery$data2 === void 0 ? void 0 : _referralQuery$data2.id : true))
    }
  });
  const personId = caseQuery === null || caseQuery === void 0 || (_caseQuery$data = caseQuery.data) === null || _caseQuery$data === void 0 || (_caseQuery$data = _caseQuery$data.data) === null || _caseQuery$data === void 0 || (_caseQuery$data = _caseQuery$data.data) === null || _caseQuery$data === void 0 || (_caseQuery$data = _caseQuery$data.person) === null || _caseQuery$data === void 0 ? void 0 : _caseQuery$data.id;
  const providerId = caseQuery === null || caseQuery === void 0 || (_caseQuery$data2 = caseQuery.data) === null || _caseQuery$data2 === void 0 || (_caseQuery$data2 = _caseQuery$data2.data) === null || _caseQuery$data2 === void 0 || (_caseQuery$data2 = _caseQuery$data2.data) === null || _caseQuery$data2 === void 0 || (_caseQuery$data2 = _caseQuery$data2.provider) === null || _caseQuery$data2 === void 0 ? void 0 : _caseQuery$data2.id;
  const service_type_id = caseQuery === null || caseQuery === void 0 || (_caseQuery$data3 = caseQuery.data) === null || _caseQuery$data3 === void 0 || (_caseQuery$data3 = _caseQuery$data3.data) === null || _caseQuery$data3 === void 0 || (_caseQuery$data3 = _caseQuery$data3.data) === null || _caseQuery$data3 === void 0 || (_caseQuery$data3 = _caseQuery$data3.service) === null || _caseQuery$data3 === void 0 ? void 0 : _caseQuery$data3.id;
  const personQuery = useFindRecord("person", personId, {
    queryConfig: {
      enabled: Boolean(personId)
    }
  });
  const providerQuery = useFindRecord("provider", providerId, {
    queryConfig: {
      enabled: Boolean(providerId)
    }
  });
  const topicQuery = useFindRecord("services", service_type_id, {
    queryConfig: {
      enabled: Boolean(service_type_id)
    }
  });
  let providerName = providerQuery.data.data.data.name;
  let personName = personQuery.data.data.data.full_name;
  let topicTitle = topicQuery.data.data.data.name;
  return {
    providerName,
    topicTitle,
    personName,
    personId
  };
};
//# sourceMappingURL=useInitializeNewConversation.js.map